import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { Send } from "lucide-react";
import { trackFormSubmission, trackWhatsAppClick } from "@/lib/analytics";

const ContactForm = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Track conversion in Google Ads & Google Analytics
    trackFormSubmission({ name: formData.name, phone: formData.phone });
    trackWhatsAppClick("contact_form");
    
    // Create WhatsApp message
    const whatsappMessage = `مرحباً، أنا ${formData.name}%0aرقم الجوال: ${formData.phone}%0aالرسالة: ${formData.message}`;
    const whatsappUrl = `https://wa.me/966552351116?text=${whatsappMessage}`;
    
    // Open WhatsApp
    window.open(whatsappUrl, '_blank');
    
    toast({
      title: "تم إرسال طلبك!",
      description: "سيتم توجيهك إلى واتساب للتواصل المباشر",
    });
    
    // Reset form
    setFormData({ name: "", phone: "", message: "" });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <Label htmlFor="name" className="text-base font-medium mb-2 block">
          الاسم الكامل
        </Label>
        <Input
          id="name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
          placeholder="أدخل اسمك الكامل"
          className="h-12 text-base"
        />
      </div>
      
      <div>
        <Label htmlFor="phone" className="text-base font-medium mb-2 block">
          رقم الجوال
        </Label>
        <Input
          id="phone"
          type="tel"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          required
          placeholder="05xxxxxxxx"
          className="h-12 text-base"
        />
      </div>
      
      <div>
        <Label htmlFor="message" className="text-base font-medium mb-2 block">
          رسالتك
        </Label>
        <Textarea
          id="message"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          required
          placeholder="كيف يمكننا مساعدتك؟"
          className="min-h-32 text-base"
        />
      </div>
      
      <Button type="submit" size="lg" className="w-full bg-gradient-primary text-foreground font-bold text-lg shadow-elegant hover:shadow-glow">
        <Send className="ml-2 h-5 w-5 text-foreground" />
        اطلب عرض سعر
      </Button>
    </form>
  );
};

export default ContactForm;
